<template>
  <div class="mainPage">

    <div v-for="group in groups" :key="group.name" class="robotContainer">
      
      <div style="width: 100%; margin-bottom: 15px;">
        <i class="el-icon-folder-opened"></i>&nbsp;{{group.name}}
      </div>
        
          <template>
            <RobotItem
              v-for="item in group.items"
              :key="item.id"
              :item="item"
              :handleClickRun="handleClickRun"
              :handleClickStop="handleClickStop"
              :handleClickUpgrade="handleClickUpgrade"
              :handleClickConfig="handleClickConfig"
            />
          </template>

    </div>
    
    <ConfigDialog
      v-if="isShowConfigDialog"
      :robotID="robotID"
      :robotName="robotName"
      :crontable="crontable"
      :handleCancelConfig="handleCancelConfig"
      :handleConfirmConfig="handleConfirmConfig"
    />
  </div>
</template>

<script>
import RobotItem from "@/components/robot/myRobot/RobotItem.vue";
import ConfigDialog from "@/components/robot/myRobot/ConfigDialog.vue";
import { listByGroup, run, stop, upgrade, config } from "@/api/robot";
import { mapState } from "vuex";
export default {
  name: "MyRobot",
  components: { RobotItem, ConfigDialog },
  data: () => {
    return {
      items: [],
      groups: [],
      isShowConfigDialog: false,
      robotID: "",
      robotName: "",
      crontable: ""
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    ...mapState(["accountInfo"])
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      listByGroup({
        userID: this.accountInfo.userID
      }).then(response => {
        this.groups = response.data;
      });
      
    },
    handleClickRun(robotID, robotName) {
      this.$confirm(this.$t('myrobot.confirm1a') + robotName + this.$t('myrobot.confirm1b'), this.$t('common.popup'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          run({
            userID: this.accountInfo.userID,
            id: robotID
          }).then(response => {
            const loading = this.$loading({
              lock: true,
              text: this.$t('myrobot.start'),
              //spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 0.7)'
            });
            setTimeout(() => {
              this.refreshData();
              loading.close();
              this.$message({
                type: "success",
                message: response.message
              });
            }, 30000);
            
          });
        })
        .catch(() => {});
    },
    handleClickStop(robotID, robotName) {
      this.$confirm(this.$t('myrobot.confirm2a') + robotName + this.$t('myrobot.confirm2b'), this.$t('common.popup'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          stop({
            userID: this.accountInfo.userID,
            id: robotID
          }).then(response => {
            const loading = this.$loading({
              lock: true,
              text: this.$t('myrobot.stop'),
              //spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 0.7)'
            });
            setTimeout(() => {
              this.refreshData();
              loading.close();
              this.$message({
                type: "success",
                message: response.message
              });
            }, 30000);
          });
        })
        .catch(() => {});
    },
    handleClickUpgrade(robotID, robotName, version) {
      this.$confirm(this.$t('myrobot.confirm3a') + robotName + this.$t('myrobot.confirm3b'), this.$t('common.popup'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          upgrade({
            userID: this.accountInfo.userID,
            version,
            id: robotID
          }).then(response => {
            this.$message({
              type: "success",
              message: response.message
            });
            this.refreshData();
          });
        })
        .catch(() => {});
    },
    handleClickConfig(robotID, robotName, crontable) {
      this.isShowConfigDialog = true;
      this.robotID = robotID;
      this.robotName = robotName;
      this.crontable = crontable;
    },
    handleCancelConfig() {
      this.isShowConfigDialog = false;
      this.robotID = "";
      this.robotName = "";
      this.crontable = "";
    },
    handleConfirmConfig(newCrontableObject) {
      config({
        userID: this.accountInfo.userID,
        id: this.robotID,
        schedule_type: newCrontableObject.runType,
        interval: newCrontableObject.intervalValue,
        intervalUnit: newCrontableObject.intervalUnit,
        allocate: `${newCrontableObject.fixedTime}:00`,
        needWeekend: Number(newCrontableObject.isIncludingWeekends)
      }).then(response => {
        this.$message({
          type: "success",
          message: response.message
        });
        this.refreshData();
        this.isShowConfigDialog = false;
      });
    }
  }
};
</script>
<style>
.robotContainer {
  margin-top: 0px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}


</style>
